module.exports = __webpack_public_path__ + "static/img/userImg.1f235ca4.png";